module.exports = __webpack_public_path__ + "media/images/icons/outlined/money-collect-eef04fc885905e327949d8f5d35d3bf7.svg";